// src/components/PlatformLayout.tsx
// Wraps routes with a platform-specific CSS class for style isolation.
// Mobile routes get .platform-mobile, desktop routes get .platform-desktop.
// This prevents CSS from one platform leaking into the other.

import React from "react";
import { useLocation } from "react-router-dom";

export type Platform = "mobile" | "desktop" | "shared";

function detectPlatform(pathname: string): Platform {
  if (pathname.startsWith("/m/") || pathname.startsWith("/m-")) return "mobile";
  if (pathname.startsWith("/d/") || pathname.startsWith("/d-")) return "desktop";
  return "shared";
}

export function PlatformLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const platform = detectPlatform(location.pathname);

  const className =
    platform === "mobile"
      ? "platform-mobile"
      : platform === "desktop"
        ? "platform-desktop"
        : "";

  return <div className={className}>{children}</div>;
}